export default function Sitemap() {
  return (
    <svg
      width="100%"
      viewBox="0 0 680 560"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>App sitemap — master routes</title>
      <desc>Top-level route structure grouped by section.</desc>

      <style>{`
        .node { cursor: pointer; }
        .th { font-family: sans-serif; font-size: 14px; font-weight: 500; fill: #3C3489; }
        .ts { font-family: sans-serif; font-size: 12px; fill: #5F5E5A; }
        .c-purple rect { fill: #EEEDFE; stroke: #534AB7; }
        .c-purple .th { fill: #3C3489; }
        .c-teal rect { fill: #E1F5EE; stroke: #0F6E56; }
        .c-teal .th { fill: #085041; }
        .c-coral rect { fill: #FAECE7; stroke: #993C1D; }
        .c-coral .th { fill: #712B13; }
        .c-amber rect { fill: #FAEEDA; stroke: #854F0B; }
        .c-amber .th { fill: #633806; }
        .c-gray rect { fill: #F1EFE8; stroke: #5F5E5A; }
        .c-gray .th { fill: #444441; }
        .c-gray .ts { fill: #5F5E5A; }
      `}</style>

      {/* ROOT */}
      <g className="c-purple">
        <rect x="270" y="20" width="140" height="38" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="340"
          y="39"
          textAnchor="middle"
          dominantBaseline="central"
        >
          / Home
        </text>
      </g>

      {/* Trunk */}
      <line
        x1="340"
        y1="58"
        x2="340"
        y2="78"
        stroke="#888"
        strokeWidth="0.5"
        opacity="0.4"
      />
      {/* Horizontal bus */}
      <line
        x1="55"
        y1="78"
        x2="632"
        y2="78"
        stroke="#888"
        strokeWidth="0.5"
        opacity="0.4"
      />

      {/* Drop lines */}
      {[55, 160, 270, 375, 480, 572, 632].map((x) => (
        <line
          key={x}
          x1={x}
          y1="78"
          x2={x}
          y2="98"
          stroke="#888"
          strokeWidth="0.5"
          opacity="0.4"
        />
      ))}

      {/* ── CONTENT ── */}
      <g className="c-teal">
        <rect x="15" y="98" width="80" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="55"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Content
        </text>
      </g>
      {[
        [150, "/sports"],
        [190, "/auto"],
        [230, "/technology"],
        [270, "/entertainment"],
        [310, "/health"],
        [350, "/feeder"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="55"
            y1={y - 20}
            x2="55"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="15"
              y={y}
              width="80"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="55"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* ── HERITAGE ── */}
      <g className="c-teal">
        <rect x="118" y="98" width="84" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="160"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Heritage
        </text>
      </g>
      {[
        [150, "/heritage/food"],
        [190, "/heritage/beauty"],
        [230, "/heritage/fitness"],
        [270, "/heritage/fashion"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="160"
            y1={y - 20}
            x2="160"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="118"
              y={y}
              width="84"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="160"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* ── TRAVEL ── */}
      <g className="c-teal">
        <rect x="228" y="98" width="84" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="270"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Travel
        </text>
      </g>
      {[
        [150, "/travel"],
        [190, "/goa-tourism"],
        [230, "/city/:cityName"],
        [270, "/traveler"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="270"
            y1={y - 20}
            x2="270"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="228"
              y={y}
              width="84"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="270"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* ── IMMIGRATION ── */}
      <g className="c-coral">
        <rect x="327" y="98" width="96" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="375"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Immigration
        </text>
      </g>
      {[
        [150, "/immigration"],
        [190, "/immigration/:country"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="375"
            y1={y - 20}
            x2="375"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="327"
              y={y}
              width="96"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="375"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}
      <line
        x1="375"
        y1="218"
        x2="375"
        y2="230"
        stroke="#888"
        strokeWidth="0.5"
        opacity="0.35"
      />
      <g className="c-gray">
        <rect x="327" y="230" width="96" height="36" rx="6" strokeWidth="0.5" />
        <text
          className="ts"
          x="375"
          y="245"
          textAnchor="middle"
          dominantBaseline="central"
        >
          13 country
        </text>
        <text
          className="ts"
          x="375"
          y="260"
          textAnchor="middle"
          dominantBaseline="central"
        >
          sub-routes
        </text>
      </g>

      {/* ── IMM. NEWS ── */}
      <g className="c-coral">
        <rect x="436" y="98" width="88" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="480"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Imm. News
        </text>
      </g>
      {[
        [150, "/news/australia"],
        [190, "/news/canada"],
        [230, "/news/uk"],
        [270, "/news/us · +4 more"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="480"
            y1={y - 20}
            x2="480"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="436"
              y={y}
              width="88"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="480"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* ── ARTICLES ── */}
      <g className="c-amber">
        <rect x="534" y="98" width="76" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="572"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Articles
        </text>
      </g>
      {[
        [150, "/articles/ai-agents"],
        [190, "/articles/ai-infra"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="572"
            y1={y - 20}
            x2="572"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="534"
              y={y}
              width="76"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="572"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* ── UTILITY ── */}
      <g className="c-gray">
        <rect x="598" y="98" width="68" height="34" rx="8" strokeWidth="0.5" />
        <text
          className="th"
          x="632"
          y="115"
          textAnchor="middle"
          dominantBaseline="central"
        >
          Utility
        </text>
      </g>
      {[
        [150, "/admin"],
        [190, "/event"],
        [230, "/privacy-policy"],
        [270, "/michigan-sahana"],
        [310, "/ram-navami"],
        [350, "/cyber-crime-alert"],
      ].map(([y, label]) => (
        <g key={label}>
          <line
            x1="632"
            y1={y - 20}
            x2="632"
            y2={y}
            stroke="#888"
            strokeWidth="0.5"
            opacity="0.35"
          />
          <g className="c-gray">
            <rect
              x="598"
              y={y}
              width="68"
              height="28"
              rx="6"
              strokeWidth="0.5"
            />
            <text
              className="ts"
              x="632"
              y={y + 14}
              textAnchor="middle"
              dominantBaseline="central"
            >
              {label}
            </text>
          </g>
        </g>
      ))}

      {/* Legend */}
      <g className="c-teal">
        <rect x="40" y="460" width="12" height="12" rx="3" strokeWidth="0.5" />
      </g>
      <text className="ts" x="58" y="466" dominantBaseline="central">
        Content / Heritage / Travel
      </text>
      <g className="c-coral">
        <rect x="230" y="460" width="12" height="12" rx="3" strokeWidth="0.5" />
      </g>
      <text className="ts" x="248" y="466" dominantBaseline="central">
        Immigration
      </text>
      <g className="c-amber">
        <rect x="350" y="460" width="12" height="12" rx="3" strokeWidth="0.5" />
      </g>
      <text className="ts" x="368" y="466" dominantBaseline="central">
        Articles
      </text>
      <g className="c-gray">
        <rect x="440" y="460" width="12" height="12" rx="3" strokeWidth="0.5" />
      </g>
      <text className="ts" x="458" y="466" dominantBaseline="central">
        Utility / other
      </text>
    </svg>
  );
}
